<template>
  <div class="container">
    <div class="searchBox">
      <van-search
        v-model="keyword"
        shape="round"
        background="transparent"
        placeholder="关键词搜索"
        @search="searchHandle"
      />
    </div>
    <div class="newsBox">
      <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getList"
      >
        <div v-for="(item, index) in list" :key="index">
          <div
            class="relatedItem"
            :class="
              item.CoverNum == 1
                ? 'setFlex'
                : '' || item.CoverNum == 0 || item.CoverNum == 3
                ? 'addpadding'
                : ''
            "
            @click="toArticleDetail(item.ContentID)"
          >
            <div class="overFlowTwo">{{ item.Title }}</div>
            <div class="imgs one" v-if="item.CoverNum == 1">
              <van-image fit="cover" :src="item.Thumbnail"></van-image>
            </div>
            <div class="imgs three" v-if="item.CoverNum == 3">
              <div v-for="(pitem, pindex) in item.ThumbnailList" :key="pindex">
                <van-image :src="pitem" fit="cover"></van-image>
              </div>
            </div>
            <div class="ri_tag">
              <span v-if="item.IsTop">置顶</span>
              <div class="overFlowOne">{{ item.Headline }}</div>
              {{ item.CreateDateDesc }}
            </div>
          </div>
        </div>
      </van-list>
      <div class="noDataBox" v-if="list.length == 0">
        <span class="iconfont icon-kong"></span>
        <div>什么也没有！</div>
      </div>
    </div>
  </div>
</template>
<script>
import { List, Search, Image } from "vant";
import { homeArticleList } from "@/api/index";
export default {
  name: "dailyNews",
  components: {
    "van-search": Search,
    "van-list": List,
    "van-image": Image,
  },
  data() {
    return {
      keyword: "",
      list: [],
      pageIndex: 1,
      total: 0,
      loading: false,
      finished: false,
      error: false,
    };
  },
  methods: {
    //跳转文章详情
    toArticleDetail(id) {
      this.$router.push({
        path: "/articleDetail",
        query: { id: id },
      });
    },

    // 搜索
    searchHandle() {
      this.pageIndex = 1;
      this.list = [];
      this.getList();
    },

    //获取列表
    getList() {
      var that = this;
      var data = {
        Keyword: that.keyword,
        Page: {
          PageSize: 20,
          PageIndex: that.pageIndex,
        },
      };
      homeArticleList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch(() => {
          that.error = true;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.newsBox {
  background: #fff;
  padding: 0 12px;
  padding-bottom: 77px;
  .relatedItem {
    padding: 15px 0px;
    border-bottom: 1px solid #eeeeee;
    position: relative;
    &:first-child {
      margin-top: 5px;
    }
  }
  .setFlex {
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-start;
    justify-content: space-between;
    div.overFlowTwo {
      width: 223px;
      margin-right: 10px;
    }
    .ri_tag {
      width: 223px;
      left: auto;
      right: 10px;
      div {
        max-width: 150px;
      }
    }
  }
  div.overFlowTwo {
    font-size: 16px;
    color: #333;
    line-height: 20px;
  }
  .imgs {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    /deep/.van-image {
      display: block;
      width: 105px;
      height: 70px;
      background-color: #d0d0d0;
    }
  }
  .one {
    width: 105px;
  }
  .three {
    margin-top: 12px;
  }
  .ri_tag {
    width: 100%;
    position: absolute;
    bottom: 15px;
    left: 0;
    z-index: 2;
    color: #999999;
    font-size: 11px;
    line-height: 12px;
    display: flex;
    align-items: center;
    span {
      color: #d62f2f;
      padding-right: 10px;
    }
    div {
      max-width: 270px;
      padding-right: 5px;
    }
  }
  .addpadding {
    padding-bottom: 36px;
  }
}
</style>